import toPLN from "../global/toPLN";
import useRole from "../../hooks/useRole";

export default function HeadingDiagrams({data}) {
    const role = useRole();

    const Score = ({value, ndValue, type, title, after}) => (
        <div className="score">
            <p>{title}</p>
            {type === "cash" ? <h6>{toPLN(value)}</h6> : <h6>{value.toFixed(2)}{after}</h6>}
            <h5 style={ndValue >= 0 ? { color: 'green'} : {color: 'red'} }>{new Number(ndValue).toFixed(2)}%</h5>
        </div>
    );

    return (
        <div className="heading-diagrams">
            <Score value={data.volume} ndValue={Number(data.comp_volume)} type="num" title="Wolumen paliw" after="l"/>
            <Score value={data.netto} ndValue={Number(data.comp_netto)} type="cash" title="Sprzedaż netto" after=""/>
            {role !== 'supply' && <Score value={data.margin} ndValue={Number(data.comp_margin)} type="cash" title="Marża netto" after=""/>}
            <Score value={data.clients} ndValue={Number(data.comp_clients)} type="num" title="Liczba klientów" after=""/>
            <Score value={data.basket} ndValue={Number(data.comp_basket)} type="cash" title="Średni koszyk" after=""/>
        </div>
    )
}
